import React from 'react'
import { getImages } from '../const'
import { Link } from 'react-router-dom'
import UseScrollReveal from '../Common/UseScrollReveal '

const Facilities = () => {
    UseScrollReveal();
    return (
        <>
            <section className='facility-wrap'>
                <div className='d-flex align-items-center flex-wrap facility-flex'>
                    <div className='w-50 facility-col'>
                        <div className='facility-box position-relative'>
                            <img src={getImages('New-Inventory.webp')} alt='New Inventory' />
                            <div className='fac-position d-flex align-items-center'>
                                <div className='w-100'>
                                    <h4 className='md-title mb-1 text-uppercase reveal wow fadeInUp'>Browse</h4>
                                    <h2 className='lg-title text-uppercase reveal wow fadeIn'>New Inventory</h2>
                                    <div className='mt-0 fac-action'>
                                        <Link to="/inventory/new" className='more-btn text-uppercase'>More <span className='more-right-icon'></span></Link>
                                    </div>
                                </div>
                            </div>
                            <Link to="/inventory/new" className='fac-icon'></Link>
                        </div>
                    </div>
                    <div className='w-50 facility-col'>
                        <div className='facility-box position-relative'>
                            <img src={getImages('Pick-up-Delivery.webp')} alt='Pre-Owned' />
                            <div className='fac-position d-flex align-items-center'>
                                <div className='w-100'>
                                    <h4 className='md-title mb-1 text-uppercase reveal wow fadeInUp'>Browse</h4>
                                    <h2 className='lg-title text-uppercase reveal wow fadeIn'>Pre-Owned</h2>
                                    <div className='mt-0 fac-action'>
                                        <Link to="/inventory/used" className='more-btn text-uppercase'>More <span className='more-right-icon'></span></Link>
                                    </div>
                                </div>
                            </div>
                            <Link to="/inventory/used" className='fac-icon'></Link>
                        </div>
                    </div>
                    <div className='w-50 facility-col'>
                        <div className='facility-box position-relative'>
                            <img src={getImages('Pre-Owned.webp')} alt='Pick-up & Delivery' />
                            <div className='fac-position d-flex align-items-center'>
                                <div className='w-100'>
                                    <h4 className='md-title mb-1 text-uppercase reveal wow fadeInUp'>Browse</h4>
                                    <h2 className='lg-title text-uppercase reveal wow fadeIn'>LEASE SPECIALS</h2>
                                    <div className='mt-0 fac-action'>
                                        <Link to="/lease-specials" className='more-btn text-uppercase'>More <span className='more-right-icon'></span></Link>
                                    </div>
                                </div>
                            </div>
                            <Link to="/lease-specials" className='fac-icon'></Link>
                        </div>
                    </div>
                    <div className='w-50 facility-col'>
                        <div className='facility-box position-relative'>
                            <img src={getImages('Service-Department.webp')} alt='Service Department' />
                            <div className='fac-position d-flex align-items-center'>
                                <div className='w-100'>
                                    <h4 className='md-title mb-1 text-uppercase reveal wow fadeInUp'>Browse</h4>
                                    <h2 className='lg-title text-uppercase reveal wow fadeIn'>Service Department</h2>
                                    <div className='mt-0 fac-action'>
                                        <Link to="/service" className='more-btn text-uppercase'>More <span className='more-right-icon'></span></Link>
                                    </div>
                                </div>
                            </div>
                            <Link to="/service" className='fac-icon'></Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Facilities